import { commonIcons } from '@apps-common/config/icons'
import { useProjectHook } from '@apps-common/hooks/useProjectHook'
import { IUnitControlRequestModel } from '@apps-common/types/portal/unit-control'
import classNames from 'classnames'

interface IProps {
  loading?: boolean
  refetch: () => void
  requestModel: IUnitControlRequestModel
  disabled: boolean
  classes?: string
}

export const PingButton = ({ loading, refetch, requestModel, disabled, classes }: IProps) => {
  const btnColorClasses = useProjectHook('bg-brand text-on-brand ', 'bg-ctx-mm-brand text-ctx-on-mm-brand')
  return (
    <button
      type='button'
      className={classNames(
        classes,
        btnColorClasses,
        'rounded-full min-w-[35px] min-h-[35px] sm:min-w-[40px] sm:min-h-[40px] flex items-center justify-center disabled:opacity-60'
      )}
      disabled={loading || disabled}
      onClick={(e) => {
        e?.stopPropagation()
        refetch()
      }}
    >
      <commonIcons.wifi className='text-[1.4rem]' />
    </button>
  )
}
